import { Link } from "react-router-dom";
import { productImg } from "@/lib/img";

export default function ArticleCard({ article, testId }) {
  const date = new Date(article.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  return (
    <Link
      to={`/article/${article.slug}`}
      data-testid={testId}
      className="group flex flex-col bg-[#E7E3D9] border-2 border-[#D3CFC0] hover:border-[#2D2D2D] transition-colors"
    >
      <div className="aspect-[16/10] overflow-hidden border-b-2 border-[#D3CFC0]">
        <img
          {...productImg(article.image_url, "(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw")}
          alt={article.title}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover vt-photo"
        />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <span className="kicker">{article.category}</span>
        <h3 className="mt-2 font-head font-semibold text-xl leading-tight text-[#1E1E1E] group-hover:text-[#2D2D2D] transition-colors">
          {article.title}
        </h3>
        <p className="mt-2 text-[#6E6E6E] text-sm leading-relaxed line-clamp-3 flex-1">{article.excerpt}</p>
        <div className="mt-4 pt-3 border-t border-[#D3CFC0] flex items-center justify-between text-xs text-[#6E6E6E]">
          <span>{date}</span>
          <span>{article.reading_time} min read</span>
        </div>
      </div>
    </Link>
  );
}
